<template>
<div class="container">
  <div class="row">
    <div class="col-sm-6 col-md-4 col-md-offset-4">
      <h1 class="text-center login-title">KICHITTO</h1>
      <div v-if="errorResponse" class="alert alert-danger" role="alert">
        <ul>
          <li v-for="e in nonFieldErrors">{{ e }}</li>
          <li v-for="errors in fieldErrors" v-if="errors.length">
            {{ formLabels[$key] }}
            <ul>
              <li v-for="e in errors">{{ e }}</li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="account-wall">
        <form class="form-signin">
          <div class="form-group">
            <div v-bind:class="{'has-error': fieldErrors.username.length}">
              <input type="text"
                     class="form-control"
                     placeholder="{{ formLabels['username'] }}"
                     v-model="username"
                     v-bind:class="{'has-error': fieldErrors.username.length}"
                     required autofocus>
            </div>
            <div v-bind:class="{'has-error': fieldErrors.password.length}">
              <input type="password"
                     class="form-control"
                     placeholder="{{ formLabels['password'] }}"
                     v-model="password"
                     required>
            </div>
          </div>
          <button class="btn btn-lg btn-primary btn-block" type="submit" @click.prevent="login">ログイン</button>
        </form>
      </div>
    </div>
  </div>
</div>
</template>


<script lang="babel">
import moment from 'moment'
import ShopType from 'ShopType'
import Cookies from 'js.cookie'

export default {
  name: 'account-login',
  data() {
    return {
      username: null,
      password: null,
      errorResponse: null,
      formLabels: {
        username: 'ユーザ名',
        password: 'パスワード',
      },
    }
  },
  computed: {
    nonFieldErrors() {
      if (this.errorResponse && this.errorResponse.body.nonFieldErrors) {
        return this.errorResponse.body.nonFieldErrors
      } else {
        return []
      }
    },
    fieldErrors() {
      let errors = {}
      let e = this.errorResponse ? this.errorResponse.body : {}

      Object.assign(errors, {
        username: e.username ? e.username : [],
        password: e.password ? e.password : [],
      })

      return errors
    },
  },
  methods: {
    login() {
      this.errorResponse = null
      let param = {username: this.username, password: this.password}
      this.apiPost('/api/1.0/accounts/login/', param).then(response => {
        let shop = response.body.data._embedded.shop
        if (shop.shopType === ShopType.SHOP) {
          let date = moment()
          let link = {
            name: 'reservations',
            params: {
              shopId: shop.pk,
              year: date.format('YYYY'),
              month: date.format('MM'),
              day: date.format('DD'),
            },
          }
          this.$router.go(link)
        } else {
          this.$router.go({name: 'index'})
        }
      }).catch(reason => {
        if (reason.error.status == 400) {
          this.errorResponse = reason.response
        }
      })
    },
  },
  mixins: [
    require('mixin/api-client.vue')
  ],
}
</script>



// WEBPACK FOOTER //
// login.vue?00b77d6e